import { render, staticRenderFns } from "./RankChangeStudentNew.vue?vue&type=template&id=51856eb6&"
import script from "./RankChangeStudentNew.vue?vue&type=script&lang=js&"
export * from "./RankChangeStudentNew.vue?vue&type=script&lang=js&"
import style0 from "./RankChangeStudentNew.vue?vue&type=style&index=0&id=51856eb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports